module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-newsletter u-relative u-color--white",
    class: ['is-' + _vm.type, _vm.active ? 'is-active' : '', _vm.loading ? 'is-loading' : '']
  }, [_c('h4', {
    staticClass: "t-text--xs-l u-color--gray u-uppercase"
  }, [_vm._v("Newsletter")]), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter__container u-marg-t-xxxs u-flex u-fit-w"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "c-newsletter__input u-block t-text--xs t-ffamilly--sofia u-color--gray u-ph-color--gray-darker u-bg--transparent",
    attrs: {
      "type": "email",
      "name": "email",
      "autocapitalize": "off",
      "autocorrect": "off",
      "placeholder": "type your email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter__submit u-flex u-flex-ai--center u-flex-jc--center u-bg--gray-darker u-bradius--circle u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._sendForm()
      }
    }
  }, [_c('img', {
    staticClass: "c-newsletter__submit__icon",
    attrs: {
      "src": "/static/medias/images/arrow-right-bold--white.png",
      "alt": "Send my email",
      "title": "Send my email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter__submit__loader u-bg--gray-dark u-bradius--circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter__message u-absolute u-pos-bl"
  }, [_c('span', {
    staticClass: "t-text--xs2 t-lspacing--x-small u-color--gray-dark",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f55ce6"}!./src/scripts/components/app-newsletter/template.html
// module id = 140
// module chunks = 0